import { Var } from './styled';

const VAR_RX = /(\{\{\s*[\w.]+\s*\}\})/g;

export default function TemplateText({ text }) {
  return String(text || '')
    .split(VAR_RX)
    .map((part, i) => (i % 2 ? <Var key={i}>{part.replace(/[{}\s]/g, '')}</Var> : part));
}
